module.exports = __webpack_public_path__ + "img/KC_SX.46c99bd6.png";